module.exports = __webpack_public_path__ + "static/media/washington-dc-63.8ba825a8.jpg";